<template lang="pug">
.sendmail-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="send" @cancel="cancel")
    div(slot="modal-title")
      span メール送信

    .sendmail-modal-body
      .register-body
        FormInput(
          key-name="宛先メールアドレス"
          required
          name="mailAddress"
          v-model="_mailAddress"
          type="text"
          placeholder="宛先メールアドレス"
          :validation-rules="{ required: true }"
          :styles="{ width: '600px', maxWidth: '600px' }"
        )
        FormInput(
          key-name="タイトル"
          required
          name="subject"
          v-model="_subject"
          type="text"
          placeholder="タイトル"
          :maxlength="100"
          :validation-rules="{ required: true, max: 100 }"
          :styles="{ width: '600px', maxWidth: '600px' }"
        )
        FormTextarea(
          key-name="本文"
          required
          name="text"
          v-model="_text"
          placeholder="本文"
          :rows="7"
          :maxlength="1000"
          :validation-rules="{ required: true, max: 1000 }"
          :styles="{ width: '600px', maxWidth: '600px', minHeight: '160px' }"
        )

    .sendmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn.mr-2(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * メール送信内容入力モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormInput,
    FormTextarea
  }
})
export default class SendMailModal extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  mailAddress!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  subject!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  text!: string;

  @Prop({
    default: () => {
      return false;
    }
  })
  showValidationAlert!: boolean;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _mailAddress(): string {
    return this.mailAddress;
  }

  set _mailAddress(newValue: string) {
    this.$emit("update:mailAddress", newValue);
    return;
  }

  get _subject(): string {
    return this.subject;
  }

  set _subject(newValue: string) {
    this.$emit("update:subject", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.$emit("update:showValidationAlert", newValue);
    return;
  }

  /**
   * ### 送信ボタン押下処理
   */
  public send(modalEvent: any): void {
    this.$emit("update:showValidationAlert", false);
    modalEvent.preventDefault();
    this.$emit("sendMail");
    return;
  }

  public cancel(): void {
    this.$emit("update:showValidationAlert", false);
    return;
  }
}
</script>
